// Considered: ChipAtom (with a `tone`) — rejected because a chip is a
// labelled pill sized to its text; the marker is a fixed-size unlabelled
// square glyph leading a dense filter row. See spec Reuse Audit.

import React from 'react';
import { useTranslation } from 'localization';
import GlyphAtom from '../Glyph/GlyphAtom';
import { FILTER_LANE_META, DEFAULT_FILTER_LANE, FilterLaneKind } from '../../../types/filterLane';
import './LaneMarkerAtom.scss';

export interface LaneMarkerAtomProps {
  /** Which of the six unified-filter lanes this row/entry belongs to. Defaults to `aspect` — the lane the prototype falls back to when unset. */
  lane?: FilterLaneKind;
  /** `sm` (catalog rows, 20px in the prototype) or `md` (filter rows, 22px). */
  size?: 'sm' | 'md';
  className?: string;
}

const LaneMarkerAtom: React.FC<LaneMarkerAtomProps> = ({
  lane = DEFAULT_FILTER_LANE,
  size = 'md',
  className = '',
}) => {
  const { t } = useTranslation();
  const meta = FILTER_LANE_META[lane] ?? FILTER_LANE_META[DEFAULT_FILTER_LANE];
  const label = t(meta.labelKey);

  return (
    <span
      className={`lane-marker-atom lane-marker-atom--${meta.token} lane-marker-atom--${size} ${className}`.trim()}
      title={label}
      aria-label={label}
      role="img"
    >
      {/* --lane-*-fg is passed as a token so the glyph icon adopts the lane's
          foreground colour — GlyphAtom's own default (--primary-text-color)
          would otherwise win over the wrapper's `color`, since the icon rule
          sets an explicit var() rather than `currentColor`. */}
      <GlyphAtom glyph={meta.icon} glyphColor={{ kind: 'token', value: `lane-${meta.token}-fg` }} />
    </span>
  );
};

LaneMarkerAtom.displayName = 'LaneMarkerAtom';

export default LaneMarkerAtom;
